import { CF } from "../../_common/layout";
import {Fragment, h} from "preact";
import {t} from '../../_i18n';

export const ConditionsUpdated = ({name}) => 
    <CF className="sm-card max-width-sm alert-commitment-fct m-bottom">
        <div className={"p-top p-bottom p-left p-right t-justify"}>
            <div dangerouslySetInnerHTML={{ __html: '<b>'+t('signature_page_conditions_updated').replace('{name}',name)+'</b>'}} />
        </div>
    </CF>; 